import React from 'react';

const Statistics = () => {
  const stats = [
    {
      number: '150+',
      label: 'Engagements delivered',
      description: 'Engagements spanning cloud, security hardening, automation, and product delivery',
      icon: (
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
          <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M2 17L12 22L22 17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M2 12L12 17L22 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      )
    },
    {
      number: '100+',
      label: 'Partner organizations',
      description: 'Organizations that trust us with infrastructure, security, and mission-critical systems',
      icon: (
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
          <path d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <circle cx="12" cy="7" r="4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      )
    },
    {
      number: '50+',
      label: 'Team Members',
      description: 'Engineers, cloud architects, security-minded operators, and product specialists',
      icon: (
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
          <path d="M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <circle cx="9" cy="7" r="4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M23 21V19C22.9993 18.1137 22.7044 17.2528 22.1614 16.5523C21.6184 15.8519 20.8581 15.3516 20 15.13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M16 3.13C16.8604 3.35031 17.623 3.85071 18.1676 4.55232C18.7122 5.25392 19.0078 6.11683 19.0078 7.005C19.0078 7.89318 18.7122 8.75608 18.1676 9.45769C17.623 10.1593 16.8604 10.6597 16 10.88" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      )
    },
    {
      number: '98%',
      label: 'Client Satisfaction',
      description: 'Average satisfaction across delivery, support, and advisory work',
      icon: (
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
          <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      )
    },
    {
      number: '24/7',
      label: 'Support Available',
      description: 'Managed operations and escalation paths when your systems cannot wait',
      icon: (
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
          <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
          <path d="M12 6V12L16 14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      )
    },
    {
      number: '10+',
      label: 'Years Experience',
      description: 'Deep bench across cloud, security, automation, and enterprise applications',
      icon: (
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
          <path d="M3 9L12 2L21 9V20C21 20.5304 20.7893 21.0391 20.4142 21.4142C20.0391 21.7893 19.5304 22 19 22H5C4.46957 22 3.96086 21.7893 3.58579 21.4142C3.21071 21.0391 3 20.5304 3 20V9Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M9 22V12H15V22" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      )
    }
  ];

  const foundation = [
    {
      title: 'Innovation',
      description: 'Practical adoption of AI, cloud, and automation—measured by throughput, cost, and risk reduction, not buzzwords.',
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
          <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M2 17L12 22L22 17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M2 12L12 17L22 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      ),
      image: 'https://images.unsplash.com/photo-1488590528505-98d2b5aba04b?w=800&h=600&fit=crop',
      color: 'primary'
    },
    {
      title: 'Excellence',
      description: 'Rigorous engineering, documentation, and handoffs so solutions survive audits, turnover, and scale.',
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
          <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      ),
      image: 'https://images.unsplash.com/photo-1552664730-d307ca884978?w=800&h=600&fit=crop',
      color: 'secondary'
    },
    {
      title: 'Integrity',
      description: 'Transparent assessments, realistic timelines, and security posture you can explain to your board.',
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
          <path d="M9 12L11 14L15 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      ),
      image: 'https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=800&h=600&fit=crop',
      color: 'primary'
    },
    {
      title: 'Growth',
      description: 'Platforms and operations that scale with you—from first serious traffic to multi-region and compliance maturity.',
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
          <path d="M3 3V21H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M7 16L12 11L16 15L21 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M21 10H16V15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      ),
      image: 'https://images.unsplash.com/photo-1551434678-e076c223a692?w=800&h=600&fit=crop',
      color: 'secondary'
    }
  ];

  return (
    <section id="statistics" className="stats-section">
      <div className="stats-background-effects">
        <div className="stats-orb stats-orb-1"></div>
        <div className="stats-orb stats-orb-2"></div>
        <div className="stats-orb stats-orb-3"></div>
      </div>
      
      <div className="container">
        <div className="stats-header">
          <span className="stats-badge">By the numbers</span>
          <h2 className="stats-title">Impact you can measure</h2>
          <p className="stats-description">
            Outcomes you can stand behind—delivery volume, partnership depth, and the operational coverage modern enterprises expect.
          </p>
        </div>

        <div className="stats-grid">
          {stats.map((stat, index) => (
            <div 
              key={index} 
              className="stats-card"
              style={{ '--delay': `${index * 0.1}s` }}
            >
              <div className="stats-card-inner">
                <div className="stats-icon-circle">
                  <div className="stats-icon">{stat.icon}</div>
                </div>
                <div className="stats-number">{stat.number}</div>
                <h3 className="stats-label">{stat.label}</h3>
                <p className="stats-text">{stat.description}</p>
              </div>
              <div className="stats-card-shine"></div>
            </div>
          ))}
        </div>

        <div className="stats-foundation">
          <div className="stats-foundation-header">
            <span className="stats-foundation-badge">Our foundation</span>
            <h3 className="stats-foundation-title">What anchors every engagement</h3>
            <p className="stats-foundation-subtitle">
              How we think about automation, security, cloud, and long-term operations—not one-off projects alone.
            </p>
          </div>
          
          <div className="stats-foundation-grid">
            {foundation.map((item, index) => (
              <div 
                key={index} 
                className={`stats-foundation-card stats-foundation-${item.color}`}
                style={{ '--delay': `${index * 0.15}s` }}
              >
                <div className="stats-foundation-image-wrapper">
                  <img 
                    src={item.image} 
                    alt={item.title}
                    className="stats-foundation-image"
                    loading="lazy"
                    onError={(e) => {
                      e.target.src = `https://via.placeholder.com/800x600/${item.color === 'primary' ? 'FF6B35' : '004E89'}/FFFFFF?text=${encodeURIComponent(item.title)}`;
                    }}
                  />
                  <div className="stats-foundation-overlay"></div>
                  <div className="stats-foundation-icon-badge">
                    <div className="stats-foundation-icon">{item.icon}</div>
                  </div>
                </div>
                <div className="stats-foundation-content">
                  <h4 className="stats-foundation-name">{item.title}</h4>
                  <p className="stats-foundation-desc">{item.description}</p>
                </div>
                <div className="stats-foundation-accent"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Statistics;
